
/**
 * @nullable
 */
export type NotificationListResponseNotificationsItemData = {[key: string]: unknown} | null;
